import React, { FC } from 'react'
import Typography from 'Components/DesignSystem/Typography/Typography'

interface MoreDetailsProps {
  min_ad_price: string;
  upc: string;
  normalized_min_ad_price: string;
  product_lifecycle_status: boolean;
}

/**
 * Read-only detail fields on DS Typography (§ 77) — same label/value grammar as
 * `Attributes.tsx`, replacing the legacy h2-label / h4-value heading soup.
 */
const MoreDetails: FC<MoreDetailsProps> = ({ min_ad_price, upc, normalized_min_ad_price, product_lifecycle_status }) => {
  const fields: Array<[string, string]> = [
    ["Product Lifecycle Status", (product_lifecycle_status as any) ?? "---"],
    ["Min AD Price", min_ad_price?.toString() ?? "---"],
    ["UPC", upc?.toString() ?? "---"],
    ["Normalized Min AD Price", normalized_min_ad_price?.toString() ?? "---"],
  ];
  return (
    <React.Fragment>
      <Typography variant="title-header" as="h3" className={`tw-mt-3 tw-ms-1 tw-text-ink`}>More Details</Typography>
      <div className={`tw-flex tw-flex-wrap tw-justify-start tw-py-2`}>
        {fields.map(([label, value]) => (
          <div key={label} className={`tw-w-1/3 tw-p-1`}>
            <Typography variant="title" as="span" className="tw-block">{label}</Typography>
            <Typography variant="body-primary" as="span" className="tw-block tw-mt-1 tw-text-ink-secondary">{value}</Typography>
          </div>
        ))}
      </div>
    </React.Fragment>
  )
}

export default MoreDetails
